import { MyCohorts } from "@/components/MyCohorts";
import type { User as UserType } from "@shared/schema";

interface ProgramsTabProps {
  user: UserType;
}

export function ProgramsTab({ user }: ProgramsTabProps) {
  return (
    <div className="space-y-8">
      <MyCohorts />
    </div>
  );
}
